import { useEffect } from 'react';

export const usePageLeave = () => {
  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      const message = 'Are you sure? All progress will be lost.';
      e.preventDefault(); // Required for Chrome
      e.returnValue = message; // Standard for most browsers
      return message; // Some older browsers require this
    };

    const handleVisibilityChange = () => {
      if (document.hidden) {
        console.log('User switched to another tab or minimized the window.');
      } else {
        console.log('User came back to the tab.');
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  useEffect(() => {
    // const handleFocus = () => setIsTabActive(true);
    const handleBlur = () => {
      console.log('add function that will be stop the quiz');
      alert(
        'Are you sure you want to leave the quiz? All progress will be lost'
      );
    };

    process.env.NODE_ENV !== 'development' &&
      window.addEventListener('blur', handleBlur);

    return () => {
      process.env.NODE_ENV !== 'development' &&
        window.removeEventListener('blur', handleBlur);
    };
  }, []);
};
